import { ReactElement, useEffect } from 'react';
import { useUINav } from '@/ui';
import { useCompanyContext, useMember } from '@/companies/providers';
import { usePagesTranslation } from '../../hooks';
import { useEditProfileAction } from '@/companies/actions';
import {
    MemberGuardianNotificationsSettingsSection,
    MemberNotificationsSettingsSection
} from '@/companies/components';

export function MemberIdNotificationsSettingsPage(): ReactElement {
    const { t } = usePagesTranslation();
    const { company } = useCompanyContext();
    const { companyUser } = useMember();
    const { isAllowed: canEditProfile, reason: editProfileReason } =
        useEditProfileAction({ user: companyUser });

    const name = companyUser.joined
        ? `${companyUser.firstName} ${companyUser.lastName}`
        : companyUser.email;

    const { setParts } = useUINav();
    useEffect(() => {
        setParts([
            { text: t('shared.labels.settings') },
            {
                text: t('shared.labels.members'),
                link: `/company/${company.id}/settings/members`
            },
            { text: name },
            { text: t('shared.labels.notifications') }
        ]);
    }, [setParts, company.id, name, t]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            <MemberNotificationsSettingsSection
                companyUser={companyUser}
                canEdit={canEditProfile}
                editDisabledReason={editProfileReason}
            />
            <MemberGuardianNotificationsSettingsSection
                companyUser={companyUser}
                canEdit={canEditProfile}
                editDisabledReason={editProfileReason}
            />
        </div>
    );
}
